/**
 *
 * @module timeUnit
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef TimeUnit
 * @type {Object}
 * @desc Defines the time unit types for creating an IntroPrice object
 *
 * @property {String} day
 * @property {String} week
 * @property {String} month
 * @property {String} year
 *
 */

/**
 *
 * @enum
 * @type {TimeUnit}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    day: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    week: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    month: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    year: null
});



// WEBPACK FOOTER //
// ./src/services/paywall/timeUnit.js